import { render, staticRenderFns } from "./WorldOverview.vue?vue&type=template&id=561bf7fa&scoped=true"
import script from "./WorldOverview.vue?vue&type=script&lang=js"
export * from "./WorldOverview.vue?vue&type=script&lang=js"
import style0 from "./WorldOverview.vue?vue&type=style&index=0&id=561bf7fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561bf7fa",
  null
  
)

export default component.exports